import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["allowNew", "labelKey"];
import getOptionLabel from './getOptionLabel';
import { isFunction } from './nodash';
function addCustomOption(results, _ref) {
  var allowNew = _ref.allowNew,
    labelKey = _ref.labelKey,
    state = _objectWithoutProperties(_ref, _excluded);
  if (!allowNew || !state.text.trim()) {
    return false;
  }

  // If the consumer has provided a callback, use that to determine whether or
  // not to add the custom option.
  if (isFunction(allowNew)) {
    return allowNew(results, state);
  }

  // By default, don't add the custom option if there is an exact text match
  // with an existing option.
  return !results.some(function (o) {
    return getOptionLabel(o, labelKey) === state.text;
  });
}
export default addCustomOption;